export enum TiposConvenioEnum {
  CONTRATO_DE_REPASSE = 1,
  CONVENIO_SEM_VALOR_FINANCEIRO = 2,
  CONVENIO_DE_DESPESA = 3,
  CONVENIO_DE_COOPERACAO_TECNICA_FINANCEIRA = 4,
  CONVENIO_DE_RECEITA = 5,
  TERMO_DE_PARCERIA = 6,
  TERMO_DE_COMPROMISSO = 7,
  CONTRATO_DE_RATEIO = 8,
  TERMO_DE_COLABORACAO = 9,
  TERMO_DE_FOMENTO = 10,
  EMENDA_IMPOSITIVA_MUNICIPAL = 11,
}